// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------- Layout (shared) ---------- */
.survey-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
    background-color: #f5f7fb;
    padding: 2rem;
    box-sizing: border-box;
  }
  
  .survey-form-wrapper {
    width: 100%;
    max-width: 900px;
    background-color: #ffffff;
    border-radius: 14px;
    box-shadow: 0 10px 30px rgba(19, 33, 68, 0.08);
    overflow: hidden;
    border: 1px solid #eef0f6;
  }
  
  /* ---------- Header (shared) ---------- */
  .survey-header {
    background: linear-gradient(135deg, #6b46c1 0%, #7c3aed 60%, #9333ea 100%);
    color: #fff;
    padding: 2rem;
    border-bottom: 5px solid rgba(255,255,255,0.15);
  }
  .survey-header h1 {
    margin: 0 0 .25rem 0;
    font-size: 2rem;
    font-weight: 800;
    letter-spacing: .2px;
  }
  .survey-header p {
    margin: 0;
    opacity: .95;
  }
  
  /* ---------- Progress (used by PostSurveyPage) ---------- */
  .progress-wrap { margin-top: 1rem; }
  .progress-bar {
    height: 8px;
    background: rgba(255,255,255,0.85);
    border-radius: 999px;
    position: relative;
    overflow: hidden;
  }
  .progress-bar::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255,255,255,0.25);
    transform: translateX(-100%);
  }
  .progress-meta {
    display: flex;
    justify-content: space-between;
    font-size: .85rem;
    margin-top: .5rem;
    opacity: .95;
  }
  
  /* ---------- Form shell (shared) ---------- */
  .survey-form { padding: 2rem; }
  .survey-section { margin-bottom: 2rem; }
  .survey-section h2 {
    font-size: 1.4rem;
    color: #1f2937;
    margin: 0 0 1rem 0;
    font-weight: 700;
  }
  
  /* ---------- Question blocks (shared) ---------- */
  .survey-question {
    padding: 1rem 1.25rem;
    border: 1px solid #eef0f6;
    border-radius: 12px;
    margin-bottom: 1rem;
    transition: box-shadow .2s ease, border-color .2s ease;
    background: #fff;
  }
  .survey-question:hover {
    box-shadow: 0 6px 18px rgba(31, 41, 55, 0.05);
    border-color: #e6e9f3;
  }
  .survey-question-text,
  .survey-question > label {
    display: block;
    font-weight: 600;
    color: #334155;
    margin-bottom: .5rem;
  }
  
  /* Text input (used by Background Survey) */
  .survey-question input[type="text"] {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
    box-sizing: border-box;
  }
  .survey-question input[type="text"]:focus {
    outline: none;
    border-color: #673ab7;
    box-shadow: 0 0 0 2px rgba(103, 58, 183, 0.2);
  }
  
  /* Textarea (used by PostSurveyPage long answers) */
  .survey-question textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
    font-family: inherit;
    box-sizing: border-box;
    margin-top: 0.5rem;
    resize: vertical;
    min-height: 100px;
  }
  .survey-question textarea:focus {
    outline: none;
    border-color: #673ab7;
    box-shadow: 0 0 0 2px rgba(103, 58, 183, 0.2);
  }
  
  /* ---------- Radio & Checkbox groups (Background Survey) ---------- */
  .radio-group label,
  .checkbox-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 400;
    cursor: pointer;
  }
  .radio-group input,
  .checkbox-group input {
    margin-right: 0.5rem;
  }
  
  /* ---------- Likert (PostSurveyPage) ---------- */
  .likert-wrap {
    display: grid;
    grid-template-columns: repeat(var(--points, 5), 1fr);
    row-gap: 0.5rem;
  }
  .likert-labels { display: contents; }
  .likert-labels .left {
    grid-column: 1;
    justify-self: start;
    font-size: 0.85rem;
    color: #6b7280;
  }
  .likert-labels .right {
    grid-column: var(--points);
    justify-self: end;
    font-size: 0.85rem;
    color: #6b7280;
  }
  .likert-scale { display: contents; }
  
  .likert-point {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: .25rem;
    padding: .4rem .35rem .6rem;
    border-radius: 10px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background .15s ease, border-color .15s ease;
    border: 1px solid transparent;
  }
  .likert-point:hover {
    background: #f7f6fe;
    border-color: #ebe9ff;
  }
  .likert-point span {
    font-size: .9rem;
    color: #4b5563;
  }
  
  .likert-point input[type="radio"] {
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 999px;
    border: 2px solid #b8c1d6;
    background: #fff;
    outline: none;
    transition: border-color .15s ease, background .15s ease;
  }
  .likert-point input[type="radio"]:checked {
    border-color: #7c3aed;
    background: radial-gradient(circle at center, #7c3aed 50%, transparent 52%);
  }
  
  /* ---------- Errors (shared) ---------- */
  .survey-error {
    color: #b91c1c;
    text-align: center;
    margin: .25rem 0 1rem;
    font-weight: 600;
  }
  
  /* ---------- Navigation (shared + click-safe) ---------- */
  .survey-nav {
    display: flex;
    gap: .75rem;
    margin-top: 1.25rem;
    padding-top: 1rem;
    border-top: 1px solid #eef0f6;
    position: relative;   /* ensure clicks land */
    z-index: 10;          /* stay above any overlapping content */
  }
  
  .survey-back-btn,
  .survey-next-btn,
  .survey-submit-btn {
    padding: .9rem 1.25rem;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    color: #111827;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform .06s ease, background .15s ease, border-color .15s ease;
  }
  .survey-back-btn:hover,
  .survey-next-btn:hover {
    background: #f3f4f6;
    border-color: #e0e7ff;
  }
  .survey-back-btn:disabled {
    opacity: .5;
    cursor: not-allowed;
  }
  
  /* Submit (primary) */
  .survey-submit-btn {
    margin-left: auto;
    background: #7c3aed;
    border-color: #7c3aed;
    color: #fff;
  }
  .survey-submit-btn:hover {
    background: #6b21a8;
    border-color: #6b21a8;
  }
  
  /* Make submit stretch when it's the only action (optional) */
  .survey-nav .survey-submit-btn:only-child { flex-grow: 1; }
  
  /* ---------- Responsive ---------- */
  @media (max-width: 640px) {
    .survey-form { padding: 1rem; }
  }
  `, "",{"version":3,"sources":["webpack://./src/SurveyPage.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA,0CAA0C;EAC1C;IACE,0EAA0E;IAC1E,WAAW;IACX,aAAa;IACb,+CAA+C;EACjD;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,SAAS;IACT,YAAY;EACd;;EAEA,4DAA4D;EAC5D,iBAAiB,gBAAgB,EAAE;EACnC;IACE,WAAW;IACX,kCAAkC;IAClC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kCAAkC;IAClC,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA,8CAA8C;EAC9C,eAAe,aAAa,EAAE;EAC9B,kBAAkB,mBAAmB,EAAE;EACvC;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,mDAAmD;EACnD;IACE,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,sDAAsD;IACtD,gBAAgB;EAClB;EACA;IACE,6CAA6C;IAC7C,qBAAqB;EACvB;EACA;;IAEE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,mDAAmD;EACnD;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA,sEAAsE;EACtE;;IAEE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;EACjB;EACA;;IAEE,oBAAoB;EACtB;;EAEA,kDAAkD;EAClD;IACE,aAAa;IACb,oDAAoD;IACpD,eAAe;EACjB;EACA,iBAAiB,iBAAiB,EAAE;EACpC;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;EACA,gBAAgB,iBAAiB,EAAE;;EAEnC;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,wDAAwD;IACxD,6BAA6B;EAC/B;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,wDAAwD;EAC1D;EACA;IACE,qBAAqB;IACrB,2EAA2E;EAC7E;;EAEA,0CAA0C;EAC1C;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB,IAAI,uBAAuB;IAC7C,WAAW,WAAW,uCAAuC;EAC/D;;EAEA;;;IAGE,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6EAA6E;EAC/E;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,6DAA6D;EAC7D,4CAA4C,YAAY,EAAE;;EAE1D,qCAAqC;EACrC;IACE,eAAe,aAAa,EAAE;EAChC","sourcesContent":["/* ---------- Layout (shared) ---------- */\n.survey-container {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    min-height: 100vh;\n    background-color: #f5f7fb;\n    padding: 2rem;\n    box-sizing: border-box;\n  }\n  \n  .survey-form-wrapper {\n    width: 100%;\n    max-width: 900px;\n    background-color: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 10px 30px rgba(19, 33, 68, 0.08);\n    overflow: hidden;\n    border: 1px solid #eef0f6;\n  }\n  \n  /* ---------- Header (shared) ---------- */\n  .survey-header {\n    background: linear-gradient(135deg, #6b46c1 0%, #7c3aed 60%, #9333ea 100%);\n    color: #fff;\n    padding: 2rem;\n    border-bottom: 5px solid rgba(255,255,255,0.15);\n  }\n  .survey-header h1 {\n    margin: 0 0 .25rem 0;\n    font-size: 2rem;\n    font-weight: 800;\n    letter-spacing: .2px;\n  }\n  .survey-header p {\n    margin: 0;\n    opacity: .95;\n  }\n  \n  /* ---------- Progress (used by PostSurveyPage) ---------- */\n  .progress-wrap { margin-top: 1rem; }\n  .progress-bar {\n    height: 8px;\n    background: rgba(255,255,255,0.85);\n    border-radius: 999px;\n    position: relative;\n    overflow: hidden;\n  }\n  .progress-bar::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: rgba(255,255,255,0.25);\n    transform: translateX(-100%);\n  }\n  .progress-meta {\n    display: flex;\n    justify-content: space-between;\n    font-size: .85rem;\n    margin-top: .5rem;\n    opacity: .95;\n  }\n  \n  /* ---------- Form shell (shared) ---------- */\n  .survey-form { padding: 2rem; }\n  .survey-section { margin-bottom: 2rem; }\n  .survey-section h2 {\n    font-size: 1.4rem;\n    color: #1f2937;\n    margin: 0 0 1rem 0;\n    font-weight: 700;\n  }\n  \n  /* ---------- Question blocks (shared) ---------- */\n  .survey-question {\n    padding: 1rem 1.25rem;\n    border: 1px solid #eef0f6;\n    border-radius: 12px;\n    margin-bottom: 1rem;\n    transition: box-shadow .2s ease, border-color .2s ease;\n    background: #fff;\n  }\n  .survey-question:hover {\n    box-shadow: 0 6px 18px rgba(31, 41, 55, 0.05);\n    border-color: #e6e9f3;\n  }\n  .survey-question-text,\n  .survey-question > label {\n    display: block;\n    font-weight: 600;\n    color: #334155;\n    margin-bottom: .5rem;\n  }\n  \n  /* Text input (used by Background Survey) */\n  .survey-question input[type=\"text\"] {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 1rem;\n    box-sizing: border-box;\n  }\n  .survey-question input[type=\"text\"]:focus {\n    outline: none;\n    border-color: #673ab7;\n    box-shadow: 0 0 0 2px rgba(103, 58, 183, 0.2);\n  }\n  \n  /* Textarea (used by PostSurveyPage long answers) */\n  .survey-question textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-family: inherit;\n    box-sizing: border-box;\n    margin-top: 0.5rem;\n    resize: vertical;\n    min-height: 100px;\n  }\n  .survey-question textarea:focus {\n    outline: none;\n    border-color: #673ab7;\n    box-shadow: 0 0 0 2px rgba(103, 58, 183, 0.2);\n  }\n  \n  /* ---------- Radio & Checkbox groups (Background Survey) ---------- */\n  .radio-group label,\n  .checkbox-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 400;\n    cursor: pointer;\n  }\n  .radio-group input,\n  .checkbox-group input {\n    margin-right: 0.5rem;\n  }\n  \n  /* ---------- Likert (PostSurveyPage) ---------- */\n  .likert-wrap {\n    display: grid;\n    grid-template-columns: repeat(var(--points, 5), 1fr);\n    row-gap: 0.5rem;\n  }\n  .likert-labels { display: contents; }\n  .likert-labels .left {\n    grid-column: 1;\n    justify-self: start;\n    font-size: 0.85rem;\n    color: #6b7280;\n  }\n  .likert-labels .right {\n    grid-column: var(--points);\n    justify-self: end;\n    font-size: 0.85rem;\n    color: #6b7280;\n  }\n  .likert-scale { display: contents; }\n  \n  .likert-point {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: .25rem;\n    padding: .4rem .35rem .6rem;\n    border-radius: 10px;\n    cursor: pointer;\n    user-select: none;\n    transition: background .15s ease, border-color .15s ease;\n    border: 1px solid transparent;\n  }\n  .likert-point:hover {\n    background: #f7f6fe;\n    border-color: #ebe9ff;\n  }\n  .likert-point span {\n    font-size: .9rem;\n    color: #4b5563;\n  }\n  \n  .likert-point input[type=\"radio\"] {\n    appearance: none;\n    width: 18px;\n    height: 18px;\n    border-radius: 999px;\n    border: 2px solid #b8c1d6;\n    background: #fff;\n    outline: none;\n    transition: border-color .15s ease, background .15s ease;\n  }\n  .likert-point input[type=\"radio\"]:checked {\n    border-color: #7c3aed;\n    background: radial-gradient(circle at center, #7c3aed 50%, transparent 52%);\n  }\n  \n  /* ---------- Errors (shared) ---------- */\n  .survey-error {\n    color: #b91c1c;\n    text-align: center;\n    margin: .25rem 0 1rem;\n    font-weight: 600;\n  }\n  \n  /* ---------- Navigation (shared + click-safe) ---------- */\n  .survey-nav {\n    display: flex;\n    gap: .75rem;\n    margin-top: 1.25rem;\n    padding-top: 1rem;\n    border-top: 1px solid #eef0f6;\n    position: relative;   /* ensure clicks land */\n    z-index: 10;          /* stay above any overlapping content */\n  }\n  \n  .survey-back-btn,\n  .survey-next-btn,\n  .survey-submit-btn {\n    padding: .9rem 1.25rem;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    background: #f9fafb;\n    color: #111827;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform .06s ease, background .15s ease, border-color .15s ease;\n  }\n  .survey-back-btn:hover,\n  .survey-next-btn:hover {\n    background: #f3f4f6;\n    border-color: #e0e7ff;\n  }\n  .survey-back-btn:disabled {\n    opacity: .5;\n    cursor: not-allowed;\n  }\n  \n  /* Submit (primary) */\n  .survey-submit-btn {\n    margin-left: auto;\n    background: #7c3aed;\n    border-color: #7c3aed;\n    color: #fff;\n  }\n  .survey-submit-btn:hover {\n    background: #6b21a8;\n    border-color: #6b21a8;\n  }\n  \n  /* Make submit stretch when it's the only action (optional) */\n  .survey-nav .survey-submit-btn:only-child { flex-grow: 1; }\n  \n  /* ---------- Responsive ---------- */\n  @media (max-width: 640px) {\n    .survey-form { padding: 1rem; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
